import { get, post } from './http-calls';

export const GetUsedVehicleDashboard = async (processID) => {
    let res = await get(`UsedVehicleDashboard/GetSalesInternalUsedVehicleSTock?ProcessID=${processID}`, { useAuthToken: true });
    return res;
};
